//
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [
  {
    name: 'pch_provider_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'alias_name',
      itemValue: 'id',
      label: 'Proveedor',
      model: ProviderModel,
      noObject: true,
      /*paramSearch: 'business_name',*/
    },
  },
]
